<template>
	<div id="main" :style="{zoom:zoomAuto}">  
		<div class="bdy">
			<div class="left-content">
				<div class="logo-content">
					<img src="../../assets/login/logo.png" alt="" class="logo-img">
				</div>
				<div class="title1">积搭即见，可视化大屏快速<br/>生成</div>
				<div class="title2">操作过程仅需3个步骤，无需学习成本，小白也能即用即上手</div>
				<div class="logo1"></div>
				<div class="logo2"></div>
			</div>
			<div class="right-content" v-if="!isorder">
				<div class="title1">Hello</div>
				<div class="title2">欢迎<em>登录</em></div>
				<div class="input-title">手机号</div>
				<input v-model="loginForm.username" type="text" placeholder="请输入手机号" class="input-content">
				<div class="input-title">密码</div>
				<input v-model="loginForm.password" type="password" placeholder="请输入密码" class="input-content">
				<!-- <div class="get-pass" @click="getPass" :class="{'default': isGet}">
					{{ isGet ? `${seconds}秒后重试` : '获取验证码'}}
				</div> -->
				<div class="read-me">
					<el-checkbox v-model="issave"></el-checkbox>
					<div class="read-text">保存密码</div>
					<el-checkbox v-model="isread"></el-checkbox>
					<div class="read-text">我已阅读并同意<em @click="toterm">《用户协议》</em>、<em @click="toprivacy">《隐私协议》</em></div>
				</div>
				<el-button type="primary" @click="user_login" class="primary-btn">登录</el-button>
				<div class="load-btm">
					还没有账号？<em @click="toOrder">去注册</em>
				</div>
			</div>
			<div class="right-content" v-else>
				<div class="title1">Hello</div>
				<div class="title2">欢迎<em>注册</em></div>
				<el-input v-model="tel" placeholder="请输入手机号" class="order-input"></el-input>
				<el-input v-model="password" placeholder="请输入密码" class="order-input" type="password"></el-input>
				<div class="order-input">
					<el-input v-model="password2" placeholder="请再次输入密码" type="password" @blur="againblur"></el-input>
					<div class="again-tips" v-if="!isright">两次输入密码不一致</div>
				</div>
				<!-- <el-input v-model="code" placeholder="请输入邀请码" class="order-input"></el-input> -->
				<div class="read-me">
					<el-checkbox v-model="isread"></el-checkbox>
					<div class="read-text">我已阅读并同意<em @click="toterm">《用户协议》</em>、<em @click="toprivacy">《隐私协议》</em></div>
				</div>
				<el-button type="primary" @click="register" class="primary-btn">注册</el-button>
				<div class="load-btm">
					已有账号？<em @click="toLogin">去登录</em>
				</div>
			</div>
		</div>  		  
	</div>
</template>

<script>
	import { userLogin} from "@/api/new";
	import { Message } from "element-ui";
	import { doreg } from '@/api/new.js'
	export default {
		data() {
			return {
				loginForm:{
					username:"",
					password:"",
				},
				issave: false,
				siteTitle:'',
				timer1: null,
				seconds: 60,
				isGet: false,
				isread: false,
				isorder: false,
				tel: '',
				password: '',
				password2: '',
				code: '124680',
				isright: true
			}
		},
		computed: {
			zoomAuto: function() {
				return document.documentElement.clientWidth / 1920; //自定义高度需求
			},
			Hframe: function() {
				console.log(window.screen.height);
				return  window.screen.height / (document.documentElement.clientWidth / 1920) + "px"; //自定义高度需求
			}
		},
		components: {
		},
		mounted() {
			let issave = localStorage.getItem('issave')
			let isread = localStorage.getItem('isread')
			if (isread == 'true') {
				this.isread = true
			} else {
				this.isread = false
			}
			if (issave == 'true') {
				this.issave = true
				let acount = localStorage.getItem('beforeAcount')
				let pass = localStorage.getItem('beforePass')
				if(acount) {
					this.loginForm.username = acount
				}
				if (pass) {
					this.loginForm.password = pass
				}
			} else {
				this.issave = false
			}
		},
		methods: {
			user_login(){
				// if(localStorage.getItem("token")){
				// 	Message.success("登录成功！");
				// 	router.push({name:'index'});
				// 	return;
				// }				
				if(!this.loginForm.username){
					Message.warning("请输入账号！");
					return;
				}
				if(!this.loginForm.password){
					Message.warning("请输入密码！");
					return;
				}
				if(!this.isread) {
					Message.warning("请阅读并勾选用户协议");
					return;
				}
				var data={
					username:this.loginForm.username,
					password:this.loginForm.password
				};
				var _this = this;
				userLogin(data).then(res => {
					if(res.status!=200){
						Message.warning(res.msg);
						return;
					}
					if(res.data){
						var user_infor = res.data.userInfo;
						localStorage.setItem("issave", this.issave)
						localStorage.setItem("isread", this.isread);
						Message.success("登录成功！");
						localStorage.setItem("HomeState","0")
						localStorage.setItem("userInfor",JSON.stringify(user_infor));
						localStorage.setItem("token",user_infor.token);
						if (this.issave) {
							localStorage.setItem('beforeAcount', this.loginForm.username)
							localStorage.setItem('beforePass', this.loginForm.password)
						}
						setTimeout(() => {
							this.$router.push({path: '/'});
						}, 100)
					}
					
				});
			},
			getPass() {
				this.isGet = true
				this.timer1 = setInterval(() => {
					if(this.seconds == 0) {
						this.seconds = 60
						clearInterval(this.timer1)
						this.timer1 = null
						this.isGet = false
					} else {
						this.seconds -= 1
					}
				}, 1000);
			},
			toOrder() {
				this.isorder = true
			},
			toLogin() {
				this.isorder = false
			},
			againblur() {
				if (this.password == this.password2) {
					this.isright = true
				} else {
					this.isright = false
				}
			},
			register() {
				if (!this.tel) {
					Message.warning("请输入注册账号");
					return
				}
				if (!this.password) {
					Message.warning("请输入密码");
					return
				}
				if (this.password !== this.password2) {
					Message.warning("两次输入密码不一致");
					return
				}
				if (!this.code) {
					Message.warning("请输入邀请码");
					return
				}
				const params = {
					username: this.tel,
					password: this.password,
					confirm_password: this.password2,
					type: 0,
					// 124680,346890,123567
					code: this.code,
				}
				doreg(params).then(res => {
					if(res.status == 200) {
						var user_infor = res.data.userInfo;
						localStorage.setItem("issave", this.issave)
						localStorage.setItem("isread", this.isread);
						Message.success("注册成功！");
						localStorage.setItem("HomeState","0")
						localStorage.setItem("userInfor",JSON.stringify(user_infor));
						localStorage.setItem("token",user_infor.token);
						if (this.issave) {
							localStorage.setItem('beforeAcount', this.loginForm.username)
							localStorage.setItem('beforePass', this.loginForm.password)
						}
						setTimeout(() => {
							this.$router.push({path: '/'});
						}, 100)
					} else {
						Message.warning(res.msg);
					}
				})
			},
			toterm() {
				this.$router.push('/term')
			},
			toprivacy() {
				this.$router.push('/privacy')
			}
		},
		beforeDestroy() {

		},

	}
</script>

<style scoped lang="scss">
#main{width:1920px;height:100%;}
.main_bg{width:1920px;height:100%;}
.bdy{width:100%;height: 100%;display: flex;background: #fff;}
.left-content {
	width: 654px;
	background: url(../../assets/login/bg1.png) no-repeat;
	background-size: 100% 100%;
	padding-left: 76px;
	position: relative;
	.logo-content {
		padding: 64px 0 0 0;
		.logo-img {
			width: 120px;
			height: 45px;
		}
	}
	.title1 {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 42px;
		color: #FFFFFF;
		line-height: 72px;
		margin-top: 172px;
	}
	.title2 {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 34px;
		margin-top: 70px;
	}
	.logo1,.logo2 {
		position: absolute;
		width: 208px;
		height: 108px;
		background: url(@/assets/login/icon.png) no-repeat;
		background-size: 100% 100%;
	}
	.logo1 {
		right: -82px;
		top: 90px;
	}
	.logo2 {
		left: 77px;
		bottom: 55px;
	}
}
.right-content {
	padding-left: 196px;
	position: relative;
	flex: 1;
	box-sizing: border-box;
	margin: auto 0;
	.title1 {
		font-family: Source Han Sans CN;
		font-weight: bold;
		font-size: 41px;
		color: #000000;
		line-height: 34px;
	}
	.title2 {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 29px;
		color: #505050;
		line-height: 29px;
		margin-top: 52px;
		em {
			color: #2261FF;
			margin: 0 8px;
		}
	}
	.input-title {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #3F3F3F;
		line-height: 34px;
		margin-top: 84px;
	}
	.input-content {
		margin-top: 10px;
		width: 630px;
		padding: 28px 6px;
		border: 0;
		border-bottom: 1px solid #DFDFDF;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #393939;
		line-height: 34px;
		&::placeholder {
			color: #B8B8B8;
		}
		&:focus {
			border: 0;
			border-bottom: 1px solid #DFDFDF;
			outline: none;
		}
		& + .input-title {
			margin-top: 36px;
		}
	}
	.get-pass {
		position: absolute;
		right: 24px;
		top: 660px;
		width: 127px;
		height: 41px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
		color: #fff;
		background: #2261FF;
		cursor: pointer;
		font-size: 18px;
		&.default {
			cursor: no-drop;
			color: #ADADAC;
			background-color: #F2F3F5;
		}
	}
	.read-me {
		display: flex;
		align-items: center;
		margin-top: 40px;
		.read-text {
			font-family: PingFang SC;
			font-weight: 400;
			font-size: 18px;
			color: #C0C0C0;
			margin-left: 16px;
			em {
				color: #2261FF;
				cursor: pointer;
			}
		}
	}
	.primary-btn {
		width: 632px;
		height: 72px;
		box-shadow: 0px 3px 20px 0px rgba(46,86,158,0.35);
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 22px;
		color: #FFFFFF;
		line-height: 34px;
		margin-top: 38px;
	}
}
</style>
<style lang="scss">
.read-me {
	.el-checkbox__inner {
		width: 20px;
		height: 20px;
		&::after {
			top: 4px;
			left: 7px;
		}
	}
	.el-checkbox {
		margin-right: 0;
	}
	.read-text {
		& + .el-checkbox {
			margin-left: 40px;
		}
	}
}
.bdy {
	.el-button--primary {
		background: #2261FF;
		border: 0;
		transition: all 0.2s linear;
		&:hover {
			background: rgba(34, 97, 255, .85);
		}
	}
	.order-input {
		width: 632px;
		margin-top: 66px;
		& + .order-input {
			margin-top: 16px;
		}
		.el-input__inner {
			height: 72px;
			line-height: 72px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 20px;
		}
		.again-tips {
			color: #F24545;
			margin-top: 12px;
			font-size: 14px;
		}
	}
}
.load-btm {
	font-family: PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #C0C0C0;
	margin-top: 48px;
	em {
		color: #2261FF;
		cursor: pointer;
	}
}
.again {
	display: flex;
}
</style>
